<script setup>
import {toMoney} from '~/utils/toMoney'
import {useCartStore} from '~/store/cart'
import {cloneDeep} from 'lodash'

const props = defineProps({
  item: {
    type: Object,
    default: null,
  },
})

const cartStore = useCartStore()

const selectedVariant = computed(() => {
  if (!props.item?.selected_variant) return null

  return props.item?.product?.variants?.find((variant) => {
    return variant.id === props.item.selected_variant
  }) || false
})

const mainImage = computed(() => {
  if (!props.item?.product?.images?.length) {
    return {image: '/img/no-image.jpg', title: 'Imagen no encontrada'}
  }

  return props.item.product.images[0]
})

function getProductPrice() {
  let currentPrice = props.item.product.price
  if (props.item.selected_variant) {
    const product = props.item.product
    const selectedVariant = product.variants.find(
      (variant) => variant.id === props.item.selected_variant
    )
    currentPrice = selectedVariant ? selectedVariant.price : currentPrice
  }

  if (currentPrice === 0) {
    currentPrice = props.item.product.price
  }

  return currentPrice
}

function getProductPath() {
  if (!props.item?.product) return ''

  const categoryPathSlug = props.item.product.categories[0].slug
  const productPathSlug = props.item.product.slug
  return `/tienda/${categoryPathSlug}/${productPathSlug}`
}

watch(() => props.item.qty, (value) => {
  if (value === props.item.qty) return
  const newItem = cloneDeep(props.item)
  newItem.qty = value

  cartStore.replaceItem(newItem)
})

const removeItem = () => {
  cartStore.removeItem(props.item)
}
</script>

<template>
  <div class="col-span-12 grid grid-cols-12 mt-5 items-start">
    <div class="col-span-12 lg:col-span-5 flex p-1 lg:justify-center xl:justify-normal">
      <NuxtLink :to="getProductPath()">
        <img class="h-[60px]" :src="mainImage.image" :alt="mainImage.title" loading="lazy"/>
      </NuxtLink>
      <h3 class="flex flex-col text-md italic mx-5">
        <span>{{ item.product.title }}</span>
        <span v-if="selectedVariant">{{ selectedVariant.title }}</span>
      </h3>
      <span v-if="selectedVariant" class="text-uppercase mb-3">
          <img
            v-if="selectedVariant.image"
            class="mr-2 w-[40px] h-[40px] rounded-full"
            :src="selectedVariant.image"
            :alt="selectedVariant.title"
            height="30"
          >
        </span>
    </div>
    <div class="col-span-12 lg:col-span-2 p-1 my-3 lg:my-0">
      <p class="text-center">
        <InputNumber
          v-model="item.qty"
          inputId="horizontal-buttons"
          showButtons
          buttonLayout="horizontal"
          :step="1"
          mode="decimal"
          :min="1"
          :max="99"
          :allowEmpty="false"
          fluid
        >
          <template #incrementbuttonicon>
            <span class="pi pi-plus"/>
          </template>
          <template #decrementbuttonicon>
            <span class="pi pi-minus"/>
          </template>
        </InputNumber>
      </p>
    </div>
    <div class="col-span-12 lg:col-span-4 flex items-center justify-between lg:justify-end p-1 text-[#363330]">
      <div class="lg:hidden col-span-12 xl:col-span-1 flex items-center cursor-pointer justify-start p-1" @click="removeItem">
        <i class="pi pi-trash text-[#363330] mr-2" style="font-size: 1.8rem"></i>
        <p class="text-xs text-red-800 font-bold italic"></p>
      </div>
      <p v-if="!selectedVariant && item.product.price_discount_percent > 0" class="text-md italic line-through lg:mr-5"><span
        class="mr-3 text-red-800 inline-table">-{{ item.product.price_discount_percent }}%</span> <span
        class="">{{ toMoney(item.product.price_original) }}</span></p>
      <p v-if="selectedVariant && selectedVariant.price_discount_percent > 0" class="text-md italic mx-5"><span
        class="mr-3">{{ selectedVariant.price_discount_percent }}%</span> <span class="">{{
          toMoney(selectedVariant.price_original)
        }}</span></p>
      <p v-if="selectedVariant && item.product.price_discount_percent > 0" class="text-md italic line-through lg:mr-5"><span
        class="mr-3 inline-table text-red-800">-{{ item.product.price_discount_percent }}%</span>
        <span class="">{{ toMoney(item.product.price_original) }}</span>
      </p>
      <p>
        <span class="text-2xl font-bold italic">{{ toMoney(getProductPrice() * item.qty) }}</span>
      </p>
    </div>
    <div class="col-span-12 xl:col-span-1 flex items-center cursor-pointer justify-center p-1 invisible lg:visible" @click="removeItem">
      <i class="pi pi-trash text-[#363330] mr-2 lg:mt-2" style="font-size: 1.5rem"></i>
      <p class="text-xs text-red-800 font-bold italic"></p>
    </div>
  </div>
</template>
